export default "__VITE_ASSET__CsGH$8on__"